import { Link } from "react-router-dom";
import { VENUES } from "@/data/site";
import { VENUE_PAGES } from "@/data/venues";

// Build a lookup from venue display name -> slug for those that have a subpage.
const VENUE_SLUG_BY_NAME = Object.fromEntries(
  Object.values(VENUE_PAGES).map((v) => [v.name, v.slug])
);

export default function Venues() {
  return (
    <section className="py-20 md:py-28 bg-[#F5F0EA] overflow-hidden relative grain">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 mb-12">
          <div className="md:col-span-6">
            <p className="overline mb-5">Recommended supplier</p>
            <h2 className="font-serif text-4xl md:text-5xl leading-[1.05] tracking-tight text-stone-900">
              Filmed at every kind of Essex wedding venue.
            </h2>
          </div>
          <div className="md:col-span-6 flex items-end">
            <p className="text-stone-600 leading-relaxed text-[1.02rem]">
              Officially recommended by 21+ Essex venues including barn weddings,
              country houses, coastal hotels and city ceremonies. Below is just a sample
              of the venues the team has filmed at, chances are, they know yours too.
            </p>
          </div>
        </div>
      </div>

      <div className="relative">
        <div className="flex marquee-track whitespace-nowrap gap-3">
          {[...VENUES, ...VENUES].map((v, i) => {
            const slug = VENUE_SLUG_BY_NAME[v];
            const base =
              "inline-flex items-center px-6 py-3 border text-sm tracking-wide bg-[#F5F0EA] transition-colors";
            if (slug) {
              return (
                <Link
                  key={i}
                  to={`/venues/${slug}`}
                  data-testid={`venue-marquee-link-${slug}`}
                  className={`${base} border-stone-700 text-stone-900 hover:bg-stone-900 hover:text-stone-50`}
                >
                  {v}
                </Link>
              );
            }
            return (
              <span
                key={i}
                className={`${base} border-stone-400/40 text-stone-700`}
              >
                {v}
              </span>
            );
          })}
        </div>
      </div>
    </section>
  );
}
